import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User updated library details',
  name: 'update_library_details',
  params: [
    {
      description: 'The accessibility of the library',
      name: 'library_accessibility',
      required: false,
      type: 'enum',
      values: ['public', 'private'],
    },
    {
      description: 'The id of the library',
      name: 'library_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The name of the library',
      name: 'library_name',
      required: false,
      type: 'string',
    },
    {
      description: 'The visibility of the library',
      name: 'library_visibility',
      required: false,
      type: 'enum',
      values: ['libraryMember', 'workspaceMember'],
    },
  ],
};

export default META;
